import React,{useEffect} from 'react'
import { Link } from 'react-router-dom'
import Header from'../Component/Header'
import Footer from'../Component/Footer'
const ToTheParents = () => {
     useEffect(() => {
        document.title = 'To The Parents -  St Peters convent School Faridabad Haryana';  
    }, []); 
  return (
    <>
    <Header/>
    <div className="innerslide">
    <ul className="breadcrumb">
     <li><Link to="/"> Home</Link> </li> 
     <li> Academics  </li> 
     <li>To The Parents </li>
 </ul>
</div>
<div className="innersec">
<div className="container">
     <div className="row">
           <div className="col-lg-12">
              <h1>To The Parents </h1>
         </div>
     </div>
     <div className="row">
       <div className="col-lg-12">
          <ul className="list">
                <li>Acknowledge the receipt of all circulars and test records.</li>
                <li>Label all the books (outside & inside) & other belongings like water bottles, lunch box, bag etc.</li>
                <li>Name slip should be pinned to the shirt till the children get identity card (ID) prepared by the school.</li>
                <li>Once the student gets the school diary, he / she is supposed to bring it daily and fill the personal record column on pg 1 to 5. The parents are requested to check the diary and go through the circulars issued by the school time to time.</li>
                <li>Leave letters are to be submitted to the class teacher well in advance in case of leave.</li>
                <li>In case of sick leave the original Medical Certificate should be submitted.</li>
                <li>Please send a small towel along with the child for lunch time and a face handkerchief with the child every day.</li>
                <li>Class work and home work are to be done in the same book.</li>
                <li>The children are encouraged to do their home work by themselves.</li>
                <li>Use four-line notebook for English.(Not applicable for classes 3rd – 8th )</li>
                <li>Use Five line notebook for Hindi.(Not applicable for classes 3rd – 8th )</li>
                <li>Use square box notebook for Mathematics work .(Not applicable for classes 3rd – 8th )</li>
                <li>Separate note books should be used for holiday homework and class tests.</li>
                <li>Please see that the children come to school neat and tidy.</li>
                <li>Syllabus, diary, ID card etc. shall be provided in due time.</li>
                <li>Parents can meet the Principal between 10.00 a.m. to 11.00 a.m.</li>
                <li>Only the parents are allowed to take their wards during the school hours with the permission of Principal.</li>
                <li>Parents are allowed to meet the teachers on Parent – Teacher meeting days only.</li>
                <li>Children should bring their lunch with them and bringing lunch by the parents during lunch break is not encouraged.</li>
                <li>There will be a fine for applying nail polish, Mahendi, Kajal and other accessories (i.e. bangles, ring, and earrings) , speaking in Hindi ,late coming and improper uniform.</li>
                <li>Full attendance will be rewarded.</li>
                <li>Irregular attendance, habitual idleness, neglect of home work, disobedience and disrespect towards the staff or bad moral influence will lead to dismissal.</li>
                </ul>
       </div>
     </div>
  </div>
</div>
<Footer/>
    </>
  )
}

export default ToTheParents
